module.exports = "<h3>\r\n    Alle Seiten der Version\r\n</h3>\r\n\r\n<app-table-template *ngIf=\"organisationUnits && columns\" [data]=\"organisationUnits\" [columns]=\"columns\"></app-table-template><br>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/versionOrganisationUnit/version.organisation.unit.component.html
// module id = 283
// module chunks = 1